// extracted by mini-css-extract-plugin
export default {"searchBar":"Searchbar_searchBar__mAXVk"};